<template>
  <figure class="product-image-area">
    <slot></slot>
  </figure>
</template>

<script>
  export default {
    name: "base-product-image-area",
    props:{
      product:{
        type:Object,
        required:true,
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-product-image-area.vue